import { pickupAddressValidate } from "../../application/dtos/pickup_address_validate";

export class pickupAddressEntity {
    constructor({client_name, id, contact, address, is_default, authorized}) {
        this.client_name = client_name;
        this.id = id;
        this.contact = contact;
        this.address = address;
        this.is_default = is_default;
        this.authorized = authorized;
    }

    isValid() {
        return pickupAddressValidate(this);
    }
}